<template>
  <ResultForm :data="lotto" @save="save"></ResultForm>
</template>
<script>
import LottoService from "@/services/lottoService"

import moment from "moment"

import ResultForm from "./ResultForm.vue"

export default {
  components: {
    ResultForm
  },
  data() {
    return {
      lotto: {
        lotto_date: moment().format("YYYY-MM-DD"),
        start_spin: moment().format("YYYY-MM-DD 20:55"),
        show_result: moment().format("YYYY-MM-DD 21:00"),
        results: {
          digit5: '',
          digit4: '',
          digit3: '',
          digit2_top: '',
          digit1: '',
          digit2_bottom: '',
          digit2_special: LottoService.randomNumber(2)
        }
      },
    }
  },
  computed: {
    digit5() {
      return this.lotto.results.digit5
    }
  },
  watch: {
    digit5(val) {
      if (val) {
        let res = val.split("")
        if (res.length === 5) {
          this.lotto.results.digit4 = `${res[1]}${res[2]}${res[3]}${res[4]}`
          this.lotto.results.digit3 = `${res[2]}${res[3]}${res[4]}`
          this.lotto.results.digit2_top = `${res[3]}${res[4]}`
          this.lotto.results.digit1 = `${res[4]}`
          this.lotto.results.digit2_bottom = `${res[0]}${res[1]}`
        } else {
          this.lotto.results.digit4 = ''
          this.lotto.results.digit3 = ''
          this.lotto.results.digit2_top = ''
          this.lotto.results.digit1 = ''
          this.lotto.results.digit2_bottom = ''
        }
      } else {
        this.lotto.results.digit4 = ''
        this.lotto.results.digit3 = ''
        this.lotto.results.digit2_top = ''
        this.lotto.results.digit1 = ''
        this.lotto.results.digit2_bottom = ''
      }
    }
  },
  methods: {
    save(data) {
      LottoService.saveResult(data).then((response) => {
        try {
          if (response.status === 'success') {
            this.$vs.notify({
              title: 'สำเร็จ!',
              text: 'บันทึกผลหวยเสร็จเรียบร้อย',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            });

            this.$router.push({ name: 'AdminResults' })
          } else {
            this.$vs.notify({
              title: 'ผิดพลาด!',
              text: 'บันทึกผลหวยไม่สำเร็จ',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        } catch (e) {
          //console.log(e)
          this.$vs.notify({
            title: 'ผิดพลาด(2)!',
            text: 'บันทึกผลหวยไม่สำเร็จ',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      })
    }
  }
}

</script>
